import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  storeStatuses: {
    fetching: false,
    received: false,
    content: []
  },
  storeGroups: {
    fetching: false,
    received: false,
    content: []
  },
  products: {
    fetching: false,
    received: false,
    content: []
  },
  networkCodes: {
    fetching: false,
    received: false,
    content: []
  },
  subsidiaryCodes: {
    fetching: false,
    received: false,
    content: []
  },
  partnerStdCodes: {
    fetching: false,
    received: false,
    content: []
  },
  priorityMatrices: {
    fetching: false,
    received: false,
    content: []
  },
  segments: {
    fetching: false,
    received: false,
    content: []
  },
  subsegments: {
    fetching: false,
    received: false,
    content: []
  }
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_FILTERS: {
      const newState = state
        .setIn([action.payload.name, 'fetching'], action.payload.data)
        .setIn([action.payload.name, 'received'], !action.payload.data)

      return newState
    }

    case types.RECEIVE_FILTERS: {
      const newState = state
        .setIn([action.payload.name, 'fetching'], false)
        .setIn([action.payload.name, 'received'], true)
        .setIn([action.payload.name, 'content'], action.payload.data)

      return newState
    }

    default: {
      return state
    }
  }
}

export default reducer
